import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root'
})
export class ColorService {
  // First color is used when one color only on chart. Following colors are widely used too.
  private static primaryColors: string[] = [
    '#76B3D4',
    '#7389B1',
    '#94738F',
    '#B55D6D',
    '#C43C41',
    '#C43C41',
    '#F1A76E',
    '#F8C76E',
    '#D3674D',
    '#D3674D',
    '#FFE76F',
    '#E7EB79',
    '#D6EB79',
    '#44ad9d',
    '#aa89f4',
    '#5dabcc',
    '#ff7877',
    '#f7cb7f',
    '#54beac',
    '#75d0e8',
    '#6bb9d9',
    '#ff8d8c',
    '#f9c072',
    '#5dc7b3',
    '#b091f4',
    '#7ac9e7',
    '#ff9897',
    '#f7cb7f',
    '#65d0ba',
    '#b599f5',
    '#89d8f4',
    '#ffa2a2',
    '#f6d187',
    '#6dd9c2',
    '#baa1f5',
    '#61c9db',
    '#ffacac',
    '#f5d68e',
    '#75e2c9',
    '#c0a8f5',
    '#4dc1cd',
    '#f1615d',
    '#fdcdac',
    '#bff29b',
    '#c5b0f5',
    '#39b9be',
    '#e5605a',
    '#ffc79c',
    '#adeb98',
    '#cbb8f5',
    '#26b0ae',
    '#f1615d',
    '#ffc18c',
    '#9be496',
    '#d0c0f5',
    '#12a89d',
    '#ffbb7b',
    '#88dd94',
    '#009f8b',
    '#e5605a',
    '#ffab45',
    '#307fa5',
    '#c46363',
    '#b9d1a8',
    '#c987c4',
    '#fdae61',
    '#3ca496',
    '#DDB9A1',
    '#FCC951',
    '#ABD9E9',
    '#8C759F',
    '#aa89f4',
    '#fd6161',
    '#ea94b6',
    '#75e2c9',
    '#ffa62e',
    '#258cbc',
    '#fcdb51',
    '#aa89f4',
    '#89d8f4',
    '#eaa77b',
    '#E569A7',
    '#ADF58E',
    '#80955D',
    '#D5CA9D',
    '#B3FCE0',
    '#FAA35C',
    '#E5C4DC',
    '#F5D68E',
    '#D9DCCA',
    '#009f8b',
    '#77EAA5',
    '#FF9100',
    '#81ACA0',
    '#A8FF72',
    '#D9CCBF',
    '#1ADBBE',
    '#E8BE15',
    '#36BB8F',
    '#E96B39',
    '#61E8CA',
    '#66FF8E',
    '#6CC15F',
    '#D9CD00',
    '#D0ECFF',
    '#F7EEE7',
    '#00B6BF',
    '#FFCD86',
    '#D9CCBF',
    '#81ACA0',
    '#E59026',
    '#f9f4f4',
    '#f9f4f6',
    '#f4f9f8',
    '#f4f8f9',
    '#f9f8f4',
    '#f6f4f9',
    '#f4f7f9',
    '#f9f6f4',
    '#136E59',
    '#FD8F8F',
    '#DDAC6C',
    '#D1C592',
    '#FF69A4',
    '#7D43FF',
    '#97B9C9',
    '#27B7EA',
    '#FFA050',
    '#54DE7F',
    '#A8CAC2',
    '#FEC7C7',
    '#EED5B5',
    '#E8E2C8',
    '#FEB3D1',
    '#BDA0FD',
    '#CBDCE4',
    '#92DBF4',
    '#FFCFA7',
    '#C8EDD9',
    '#B3E2CD',
    '#E7FCEC',
    '#CEF9B8',
    '#A6E9FF',
    '#FEF79F',
    '#FFD5A9',
    '#A8ED90',
    '#7AD6FF',
    '#FEF16F',
    '#FFB77E',
    '#83DB70',
    '#59C3FF',
    '#FDEA4C',
    '#FF9B5D',
    '#51C444',
    '#23A3FF',
    '#FCE111',
    '#FF6C28',
    '#239185'
  ]

  static disabledColor = '#DBD9DA'

  static getColors(shuffle?: boolean): string[] {
    return shuffle
      ? ColorService.shuffleArray(ColorService.primaryColors)
      : ColorService.primaryColors
  }

  static shuffleArray(array: any[]): any[] {
    // Clone array to prevent modifying other objects.
    const arrayClone = JSON.parse(JSON.stringify(array))

    for (let i = arrayClone.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1))
      ;[arrayClone[i], arrayClone[j]] = [arrayClone[j], arrayClone[i]]
    }
    return arrayClone
  }
}
